export class FiltroResultadoAvaliacao {
	idOrgao?: number;
	idProcessoAvaliativo?: number;
	idCiclo?: number;
	page!: number;
	size!: number;
	sort?: string;
}
